export type AppErrorKind =
  | 'network'
  | 'timeout'
  | 'cancelled'
  | 'auth'
  | 'paymentRequired'
  | 'client'
  | 'server'
  | 'unknown';

export class AppError extends Error {
  constructor(
    message: string,
    public kind: AppErrorKind,
    public status?: number,
    public data?: unknown,
    public cause?: unknown
  ) {
    super(message);
    this.name = 'AppError';
  }
}

export const isAppError = (error: unknown): error is AppError => error instanceof AppError;
